import { IANATimeZoneMap } from "@chopshop/tz/lib/tz";
import { IOrganizationBillingTime } from "@smartrr/shared/entities/Organization";

import { updateOutOfStockItemRemovalEnabled } from "@vendor-app/app/_state/actionCreators/organization";
import { GeneralSmartrrDispatch } from "@vendor-app/app/_state/typedVendorRedux";

interface InitialValues {
  orgBillingTime: IOrganizationBillingTime;
  orgBillingTimeZone: keyof IANATimeZoneMap;
  orgNumBillingRetries: number | null | undefined;
  orgNumFailedCyclesBeforeCancel: number | null | undefined;
  orgDelayBetweenRetries: number | null | undefined;
  selectedBillingDays: string[];
  billingConfirmationWaitingDays: number | null | undefined;
  outOfStockItemRemovalEnabled: boolean | null | undefined;
}

export async function handleOutOfStockItemRemovalUpdate(
  outOfStockItemRemovalEnabled: boolean | null | undefined,
  initialValues: InitialValues,
  dispatch: GeneralSmartrrDispatch,
  addToast: (content: string, error?: boolean) => void
) {
  if (typeof outOfStockItemRemovalEnabled !== "boolean") {
    addToast("Select a valid out of stock item removal setting");
    return;
  }

  await dispatch(updateOutOfStockItemRemovalEnabled(outOfStockItemRemovalEnabled)).then(res => {
    if (res.type === "UPDATED_OUT_OF_STOCK_ITEM_REMOVAL") {
      addToast("Out of stock item removal setting updated");
      initialValues.outOfStockItemRemovalEnabled = res.payload.outOfStockItemRemovalEnabled;
    }
  });
}
